import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import EmptyState from './EmptyState';
import { formatDate } from '../utils';

export default function RecentLinksTab({ recentLinks }) {
  if (recentLinks.length === 0) {
    return (
      <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm">
        <div className="border-b border-slate-100 px-5 py-4">
          <h3 className="text-base font-semibold text-slate-900">Recent affiliate links</h3>
          <p className="mt-0.5 text-sm text-slate-500">Latest created links</p>
        </div>
        <div className="p-12">
          <EmptyState
            message="No links yet"
            subMessage="Affiliate links will show here when created."
          />
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm">
      <div className="border-b border-slate-100 px-5 py-4">
        <h3 className="text-base font-semibold text-slate-900">Recent affiliate links</h3>
        <p className="mt-0.5 text-sm text-slate-500">Latest created links</p>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-100">
          <thead className="bg-slate-50/80">
            <tr>
              <th className="px-5 py-3 text-left text-xs font-medium uppercase tracking-wider text-slate-500">
                Short code
              </th>
              <th className="px-5 py-3 text-left text-xs font-medium uppercase tracking-wider text-slate-500">
                Link
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Visits
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Unique
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Conversions
              </th>
              <th className="px-5 py-3 text-left text-xs font-medium uppercase tracking-wider text-slate-500">
                Created
              </th>
              <th className="px-5 py-3 text-left text-xs font-medium uppercase tracking-wider text-slate-500">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {recentLinks.map((link) => (
              <tr key={link._id} className="hover:bg-slate-50/50">
                <td className="px-5 py-3">
                  <code className="rounded bg-slate-100 px-2 py-1 font-mono text-xs text-slate-700">
                    {link.shortCode || '—'}
                  </code>
                </td>
                <td className="max-w-[220px] px-5 py-3">
                  <a
                    href={link.generatedLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 truncate text-sm text-orange-600 hover:text-orange-700"
                  >
                    {link.generatedLink || '—'}
                    <FiExternalLink className="h-3 w-3 shrink-0" />
                  </a>
                </td>
                <td className="px-5 py-3 text-right text-sm text-slate-600">
                  {(link.visits ?? 0).toLocaleString()}
                </td>
                <td className="px-5 py-3 text-right text-sm text-slate-600">
                  {(link.uniqueVisits ?? 0).toLocaleString()}
                </td>
                <td className="px-5 py-3 text-right text-sm text-slate-600">
                  {link.conversions ?? 0}
                </td>
                <td className="px-5 py-3 text-sm text-slate-500">
                  {formatDate(link.createdAt)}
                </td>
                <td className="px-5 py-3">
                  <span
                    className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
                      link.status === 'Active'
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'bg-slate-100 text-slate-600'
                    }`}
                  >
                    {link.status || '—'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
